import { render, staticRenderFns } from "./CalendarIcon.vue?vue&type=template&id=70b1f9dc"
import script from "./CalendarIcon.vue?vue&type=script&lang=ts"
export * from "./CalendarIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70b1f9dc')) {
      api.createRecord('70b1f9dc', component.options)
    } else {
      api.reload('70b1f9dc', component.options)
    }
    module.hot.accept("./CalendarIcon.vue?vue&type=template&id=70b1f9dc", function () {
      api.rerender('70b1f9dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/CalendarIcon.vue"
export default component.exports